import { Box, Image } from '@hover/blueprint';
import type { BoxProps } from '@hover/blueprint';
import React from 'react';

interface UploadImageBoxProps extends BoxProps {
  borderRadius?: number;
  imageUrl: string;
}

export const UploadImageBox = ({
  borderRadius = 200,
  imageUrl,
  ...props
}: UploadImageBoxProps) => (
  <Box
    alignItems="center"
    borderRadius={borderRadius}
    data-testid="upload-image-box"
    flex={2}
    height={{ base: 600, tablet: '100%' }}
    justifyContent="center"
    overflow="hidden"
    {...props}
  >
    <Image
      alt="uploaded image"
      borderRadius={borderRadius}
      height="fit-content" // not supported in some browsers, the border radius may not be displayed there
      maxHeight="100%"
      maxWidth="100%"
      objectFit="contain"
      src={imageUrl}
      width="fit-content" // not supported in some browsers, the border radius may not be displayed there
    />
  </Box>
);
